import * as actionTypes from './actionTypes'

const initialState = {
    rewardList: { rewards: [], total: 0, pageSize: 0, error: null, loading: false },
    serviceList: { services: [], error: null, loading: false },
    rewardClaimed: { reward: null, error: null, loading: false },
    currentGift: { gift: null, error: null, loading: false },
    setCurrentGift: { error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {
        // #region fetch_rewards
        case actionTypes.FETCH_REWARDS:
            return {
                ...state,
                rewardList: {
                    rewards: [],
                    error: null,
                    loading: true,
                }
            }

        case actionTypes.FETCH_REWARDS_SUCCESS:
            return {
                ...state,
                rewardList: {
                    rewards: action.payload.rewards,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false,
                }
            }

        case actionTypes.FETCH_REWARDS_FAILURE:
            return {
                ...state,
                rewardList: {
                    rewards: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_REWARDS:
            return { ...state, rewardList: initialState.rewardList }
        // #endregion

        // #region fetch_services
        case actionTypes.FETCH_SERVICES:
            return { ...state, serviceList: { services: [], error: null, loading: true } }

        case actionTypes.FETCH_SERVICES_SUCCESS:
            return { ...state, serviceList: { services: action.payload.services, error: null, loading: false } }

        case actionTypes.FETCH_SERVICES_FAILURE:
            return { ...state, serviceList: { services: [], error: action.payload.error, loading: false } }
        // #endregion

        // #region claim_reward
        case actionTypes.CLAIM_REWARD:
            return { ...state, rewardClaimed: { reward: null, error: null, loading: true } }

        case actionTypes.CLAIM_REWARD_SUCCESS:
            return { ...state, rewardClaimed: { reward: action.payload.reward, error: null, loading: false } }

        case actionTypes.CLAIM_REWARD_FAILURE:
            return { ...state, rewardClaimed: { reward: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_CLAIM_REWARD:
            return { ...state, rewardClaimed: initialState.rewardClaimed }
        // #endregion

        // #region current_gift
        case actionTypes.FETCH_CURRENT_GIFT:
            return { ...state, currentGift: { gift: null, error: null, loading: true } }

        case actionTypes.FETCH_CURRENT_GIFT_SUCCESS:
            return { ...state, currentGift: { gift: action.payload.gift, error: null, loading: false } }

        case actionTypes.FETCH_CURRENT_GIFT_FAILURE:
            return { ...state, currentGift: { gift: null, error: action.payload.error, loading: false } }
        // #endregion

        // #region set_current_gift
        case actionTypes.SET_CURRENT_GIFT:
            return { ...state, setCurrentGift: { error: null, loading: true } }

        case actionTypes.SET_CURRENT_GIFT_SUCCESS:
            return { ...state, setCurrentGift: { error: null, loading: false } }

        case actionTypes.SET_CURRENT_GIFT_FAILURE:
            return { ...state, setCurrentGift: { error: action.payload.error, loading: false } }
        // #endregion

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reward/reducer.js